<div class="col-12">

  <div class="bs-callout bs-callout-info">
    <h6 class="input-group-append float-end pt-1" *ngIf="pedidoIntervencaoId > 0">Estado: <span class="text-info">&nbsp;{{pedidoIntervencao.estado}}&nbsp;</span></h6>
    <h5 class="titulo-bloco"> Pedido de Intervenção (Nº <b>{{pedidoIntervencaoId <= 0 ? '*' : pedidoIntervencaoId}}</b>)</h5>
    <hr />

    <form #form [formGroup]="pedidoForm" (ngSubmit)="save()">
      <!-- Contrato -->
      <div class="row">
        <div class="form-group input-group-sm col-sm-2">
          <label class="form-label" for="numContrato">Nº Contrato</label>
          <div class="form-group input-group input-group-sm mb-2">
            <input type="text" class="form-control input-sm" #inpNumContrato formControlName="numContrato"
              style="text-transform: uppercase;" (keydown.enter)="searchContrato(inpNumContrato.value, false)"
              [readonly]="isReadOnly() || isUpdate()">
            <div class="input-group-append">
              <button id="numContrato" class="btn btn-sm btn-outline-secondary" type="button"
                *ngIf="!isReadOnly() && !isUpdate()" (click)="searchContrato(inpNumContrato.value, false)">
                <span class="fa fa-search" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>

        <div class="form-group input-group-sm col-sm-2">
          <label class="form-label" for="matricula">Matrícula</label>
          <div class="input-group input-group-sm mb-2">
            <input type="text" class="form-control input-sm" #inpMatricula formControlName="matricula"
              style="text-transform: uppercase;" (keydown.enter)="searchContrato(inpMatricula.value, true)"
              [readonly]="isReadOnly() || isUpdate()">
            <div class="input-group-append">
              <button id="matricula" class="btn btn-sm btn-outline-secondary" type="button"
                *ngIf="!isReadOnly() && !isUpdate()" (click)="searchContrato(inpMatricula.value, true)">
                <span class="fa fa-search" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>

        <div class="form-group input-group-sm col-sm-6">
          <label class="form-label" for="produto">
            <span>Modelo</span>
            <small class="text-danger" *ngIf="pedidoForm.get('produto').invalid"> Selecione um contrato válido </small>
          </label>
          <input type="text" class="form-control input-sm" readonly="readonly" formControlName="produto">
        </div>

        <div class="form-group input-group-sm col-sm-2">
          <label class="form-label" for="data">
            <span>Data Pedido</span>
            <small class="text-danger"></small>
          </label>
          <input type="text" class="form-control input-sm" *ngIf="pedidoIntervencaoId > 0" readonly="readonly"
            formControlName="data" [value]="pedidoForm.get('data').value | date: 'yyyy-MM-dd HH:mm'">
          <input type="text" class="form-control input-sm" *ngIf="pedidoIntervencaoId <= 0" readonly="readonly"
            [value]="'*'">
        </div>
      </div>

      <!-- Fornecedor / Oficina  -->
      <div class="row">
        <div class="form-group input-group-sm mb-2 col-sm-7">
          <label class="form-label" for="fornecedor">
            <span class="is-required">Fornecedor</span>
            <small class="text-danger" *ngIf="pedidoForm.get('fornecedorId').invalid"> Obrigatório </small>
          </label>
          <select required class="form-select input-sm" id="fornecedor" name="fornecedor" formControlName="fornecedorId"
            (change)="getOficinas()">
            <option selected disabled value=""></option>
            <option *ngFor="let elem of fornecedoresCC" [value]="elem.entidadeId">
              {{elem.nome}}
            </option>
          </select>
        </div>
        <div class="form-group input-group-sm mb-2 col-sm-5">
          <label class="form-label" for="oficina"><span>Oficina</span></label>
          <select class="form-select input-sm" id="oficina" name="oficina" formControlName="oficinaId">
            <option value=""></option>
            <option *ngFor="let elem of oficinasCC" [value]="elem.oficinaId">
              {{elem.nome}}
            </option>
          </select>
        </div>
      </div>

      <!-- Kms / Data Entrada Oficina-->
      <div class="row">
        <div class="form-group input-group-sm mb-2 col-sm-2">
          <label class="form-label" for="kms" title="" placeholder="">
            <span>Nº Kms</span>
            <small class="text-danger" *ngIf="pedidoForm.get('numKms').invalid"> Obrigatório </small>
          </label>
          <input type="number" class="form-control input-sm" id="kms" name="kms" formControlName="numKms" [readonly]="isReadOnly()">
        </div>
        <div class="form-group input-group-sm mb-2 col-sm-5">
          <label class="form-label" for="dataEntradaOficina">
            <label class="form-label" for="ngbDataEntradaOficina">Data Entrada Oficina</label>
            <!-- <small class="text-danger" *ngIf="pedidoForm.get('dataEntradaOficina').invalid"> Obrigatório </small> -->
            <div class="input-group input-group-sm">
              <input class="form-control" placeholder="dd-MM-yyyy" id="ngbDataEntradaOficina" style="color: black;"
                [(ngModel)]="ngbDataEntradaOficina" ngbDatepicker #di="ngbDatepicker" [readonly]="isReadOnly() || isUpdate()"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="selectDataEntradaOficina(ngbDataEntradaOficina)"
                pattern="[0-9]{4}[-][0-9]{2}[-][0-9]{2}" >
              <button class="btn btn-sm btn-outline-secondary" title="" (click)="di.toggle()" type="button" [disabled]="isReadOnly()">
                <img src="/assets/images/calendar-icon.svg" style="width: 1.0rem; height: 1rem; cursor: pointer;" />
              </button>
            </div>
            </label>
        </div>
      </div>

      <!-- Descritivo -->
      <div class="row">
        <div class="form-group input-group-sm mb-2 col-sm-12">
          <label class="form-label" for="descritivo">
            <span>Descritivo do pedido</span>
            <small class="text-danger" *ngIf="pedidoForm.get('descritivo').invalid"> Obrigatório </small>
          </label>
          <textarea required class="form-control input-sm" id="descritivo" name="descritivo" [readonly]="isReadOnly()"
            formControlName="descritivo"></textarea>
        </div>
      </div>

      <!-- Tipo Interveção / Tipo Operação -->
      <div class="row">
        <div class="form-group input-group-sm mb-2 col-sm-6">
          <label class="form-label" for="tipoIntervencao">
            <span>Tipo de Intervenção</span>
            <small class="text-danger" *ngIf="pedidoForm.get('tipoIntervencao').invalid"> Obrigatório </small>
          </label>
          <select multiple required class="form-select form-select-sm custom-select" size="5"
            formControlName="tipoIntervencao" (change)="getTipoOperacao()">
            <option *ngFor="let elem of tipoIntervencao" [value]="elem.tipoIntervencaoId">
              {{elem.descricao}}
            </option>
          </select>
        </div>

        <div class="form-group input-group-sm mb-2 col-sm-6">
          <label class="form-label" for="artigoFamilia">
            <span>Tipo de Operação</span>
            <small class="text-danger" *ngIf="pedidoForm.get('tipoOperacao').invalid"> Obrigatório </small>
          </label>
          <select multiple class="form-select form-select-sm" size="5" formControlName="tipoOperacao">
            <option *ngFor="let elem of artigoFamilia" [value]="elem.artigoFamiliaId">
              {{elem.descricao}}
            </option>
          </select>
        </div>
      </div>

      <!-- Comandos -->
      <hr />
      <div class="clearfix">
        <button type="button" class="btn btn-sm btn-primary" (click)="back()"> Voltar </button>

        <button type="submit" [disabled]="(!pedidoForm.valid || pedidoForm.pristine || contrato?.intervencoesEmAberto)"
          *ngIf="!isReadOnly()" class="btn btn-sm btn-success float-end" [ladda]='saving'> Gravar </button>
        <button type="button" *ngIf="permiteCancelarPedido()" (click)="cancelarPedido()"
          class="btn btn-sm btn-danger float-end me-2" [ladda]='canceling'> Cancelar Pedido </button>
        <button type="button" *ngIf="permiteFecharPedido()" (click)="fecharPedido()"
          class="btn btn-sm btn-success float-end me-2" [ladda]='closing'> Fechar Pedido </button>
        <button type="button" *ngIf="pedidoIntervencaoId > 0" (click)="imprimirPedido()"
          class="btn btn-sm btn-primary float-end me-2" [ladda]='priting'> Imprimir </button>
        <button type="button" *ngIf="pedidoIntervencaoId > 0" class="btn btn-sm btn-dark float-end me-2" (click)="showHistoricoEstado()"> Histórico Estados </button>
        <h7 class="input-group-append text-danger float-end pt-1" *ngIf="contrato?.intervencoesEmAberto">Contrato com
          intervenções em curso &nbsp;</h7>
      </div>
    </form>

  </div>
</div>

<ng-template #modalCancelarPedido let-c="close" let-d="dismiss">
  <div class="modal-body" style="margin:10px;">
    <h4>Cancelar pedido de intervenção</h4>
    <hr />

    <div class="jumbotron p-0">
      <form>
        <div class="input-group-sm">
          <label class="form-label" for="observacoes">Observações :</label>
          <textarea type="text" class="form-control input-sm" id="observacoes" name="popupRemarks"
            [(ngModel)]="popupRemarks"></textarea>
        </div>

      </form>
    </div>

    <div class="text-end mt-4">
      <button type="button" class="btn btn-sm btn-primary" (click)="c('NoConfirm')">Cancelar</button>&nbsp;
      <button type="button" class="btn btn-sm btn-danger" (click)="c('Confirm')">Confirmar</button>
    </div>
  </div>
</ng-template>

<ng-template #modalFecharPedido let-c="close" let-d="dismiss">
  <div class="modal-body" style="margin:10px;">
    <h4>Fechar pedido de intervenção</h4>
    <hr />

    <div class="jumbotron p-0">
      <form>
  
        <div class="form-group form-group-sm col-sm-6 pb-3">
          <label for="dataInicio" class="form-label">
            <span>Data Entrada Oficina</span>
            <small class="text-danger" *ngIf="ngbDataEntrada === undefined">  Obrigatório </small>
          </label>
          <div class="input-group input-group-sm pt-1">
            <input class="form-control" placeholder="aaaa-mm-dd" name="dataEntradaOficina" style="color: black;"
              ngbDatepicker #di="ngbDatepicker" required [minDate]="ngbMinDataEntrega" 
              [(ngModel)]="ngbDataEntrada" (ngModelChange)="selectDataEntrada(ngbDataEntrada)" 
              [ngModelOptions]="{updateOn: 'blur'}" pattern="[0-9]{4}[-][0-9]{2}[-][0-9]{2}">
            <button class="btn btn-sm btn-outline-secondary" (click)="di.toggle()" type="button">
              <img src="/assets/images/calendar-icon.svg" style="width: 1.0rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>

        <div class="form-group form-group-sm col-sm-6 pb-3">
          <label class="form-label" for="dataEntrega">
            <span>Data Entrega</span>
            <small class="text-danger" *ngIf="ngbDataEntrega === undefined">  Obrigatório </small>
          </label>
          <div class="input-group input-group-sm col-sm-4">
            <input class="form-control" placeholder="aaaa-mm-dd" name="dataSaidaOficina" style="color: black;"
              ngbDatepicker #df="ngbDatepicker" required [minDate]="ngbMinDataEntrega" 
              [(ngModel)]="ngbDataEntrega" (ngModelChange)="selectDataSaida(ngbDataEntrega)" 
              [ngModelOptions]="{updateOn: 'blur'}" pattern="[0-9]{4}[-][0-9]{2}[-][0-9]{2}">
            <button class="btn btn-sm btn-outline-secondary" (click)="df.toggle()" type="button">
              <img src="/assets/images/calendar-icon.svg" style="width: 1.0rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>

        <div class="form-group input-group-sm">
          <label class="form-label" for="observacoes">Observações :</label>
          <textarea type="text" class="form-control input-sm" id="observacoes" name="popupRemarks"
            [(ngModel)]="observacoes"></textarea>
        </div>
      </form>
    </div>

    <div class="text-end mt-4">
      <button type="button" class="btn btn-sm btn-primary" (click)="c('NoConfirm')">Cancelar</button>&nbsp;
      <button type="button" class="btn btn-sm btn-success" (click)="c('Confirm')" [disabled]="ngbDataEntrada === undefined || ngbDataEntrega === undefined">Confirmar</button>
    </div>
  </div>
</ng-template>

<ng-template #modalHistoricoEstados let-c="close" let-d="dismiss">
  <div class="modal-header m-2">
    <h4>Histórico de Estados</h4>
    <button type="button" class="btn btn-sm btn-outline-secondary close" data-dismiss="dialog" (click)="c('Close')">
      <span aria-hidden="true">&times;</span>
      <span class="sr-only">Close</span>
    </button>
  </div>
  <div class="modal-body m-2">
    <table class="table table-sm table-striped">
      <thead class="thead-dark">
        <tr>
          <th scope="col">#</th>
          <th scope="col">Estado</th>
          <th scope="col">Data</th>
          <th scope="col">Utilizador</th>
          <th scope="col">Descritivo</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let he of popupListData; index as i" class="sm">
          <td><small>{{ he.numLinha }}</small></td>
          <td><small>{{ he.estado }}</small></td>
          <td><small>{{ he.data | date: 'dd/MM/YYYY HH:mm' }}</small></td>
          <td><small>{{ he.utilizador }}</small></td>
          <td><small>{{ he.descritivo }}</small></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer m-2">
    <button type="button" class="btn btn-sm btn-secondary" (click)="c('Close')">Fechar</button>
  </div>
</ng-template>
